import React from 'react';

const RoundedAdd = props => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="12" cy="12" r="11.5" fill="#F9F5FF" stroke="#6930CA" />
    <path
      d="M17.0068 12.8332H12.8335V17.0066C12.8335 17.2276 12.7457 17.4396 12.5894 17.5958C12.4331 17.7521 12.2212 17.8399 12.0002 17.8399C11.7791 17.8399 11.5672 17.7521 11.4109 17.5958C11.2546 17.4396 11.1668 17.2276 11.1668 17.0066V12.8332H6.99349C6.77248 12.8332 6.56051 12.7454 6.40423 12.5892C6.24795 12.4329 6.16016 12.2209 6.16016 11.9999C6.16016 11.7789 6.24795 11.5669 6.40423 11.4107C6.56051 11.2544 6.77248 11.1666 6.99349 11.1666H11.1668V6.99325C11.1668 6.77223 11.2546 6.56027 11.4109 6.40399C11.5672 6.24771 11.7791 6.15991 12.0002 6.15991C12.2212 6.15991 12.4331 6.24771 12.5894 6.40399C12.7457 6.56027 12.8335 6.77223 12.8335 6.99325V11.1666H17.0068C17.2278 11.1666 17.4398 11.2544 17.5961 11.4107C17.7524 11.5669 17.8402 11.7789 17.8402 11.9999C17.8402 12.2209 17.7524 12.4329 17.5961 12.5892C17.4398 12.7454 17.2278 12.8332 17.0068 12.8332Z"
      fill="#6930CA"
    />
  </svg>
);

export default RoundedAdd;
